import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

Vue.config.productionTip = false

new Vue({
  vuetify,
  created() {
    firebase.initializeApp(
      {
        apiKey: "AIzaSyAnI6c2bkDyyvIx-Pq5zBzu3vIMdtDZZSE",
        authDomain: "azoma-airone-asia.firebaseapp.com",
        databaseURL: "https://azoma-airone-asia.firebaseio.com",
        projectId: "azoma-airone-asia",
        storageBucket: "azoma-airone-asia.appspot.com",
        messagingSenderId: "659227406180",
        appId: "1:659227406180:web:b428ea86855bb3d727d471"
      }
    )
  },
  render: function (h) { return h(App) }
}).$mount('#app')
